export default __webpack_public_path__ + "static/team-Raymond-fce0ded4ea393d51bfeae9b7177e3dfc.png";